import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {Rating} from "../models/Rating";

export class RatingRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    query(schema: string, ids: string[]) {
        return this.client.post<Rating[]>(`/ratings/${schema}/query`, ids)
            .then(({data}) => {
                return data.map(item => new Rating(item));
            })
    }

    rate(schemaId: string, objectId: string, rate: number|null) {
        return this.client.post(`/ratings/${schemaId}/${objectId}`, rate)
            .then(({data}) => {
                return !!data;
            })
    }
}